import Header from "components/Headers/Header";
import TabsInfoModal from "components/Modal/TabsInfoModal";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Col, Container, Row, Spinner, Table } from "reactstrap";
import { fetchTopics } from "store/actions/topicsAction";

const TopicsCount = () => {
  const dispatch = useDispatch();
  const { topics } = useSelector((state) => state.a4bTopics);
  const infoPoints = [
    "This section provides the admin with an overview of how many chats have taken place on each topic, showing the topic name alongside the corresponding chat count.",
  ];
  const subPoints = [];
  const infoTitle = "Topic Chats Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  useEffect(() => {
    dispatch(fetchTopics());
  }, []);
  return (
    <>
      <Header />
      <Container fluid className="my-4">
        <Row>
          <h2
            className="mb-0 ml-auto m-2 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </Row>
        <Card className="p-2">
          <Row>
            <Col sm="12">
              <Table className="align-items-center table-flush mt-3" responsive>
                <thead>
                  <tr>
                    <th
                      scope="col"
                      className="custom-table-heading custom-heading"
                    >
                      Topic Name
                    </th>
                    <th
                      scope="col"
                      className="custom-table-heading custom-heading"
                    >
                      Chat Count
                    </th>
                  </tr>
                </thead>
                <tbody className="custom-table-body mt-3">
                  {topics.length > 0 ? (
                    topics?.map((topic, index) => {
                      return (
                        <tr key={index}>
                          <td>{topic.name}</td>
                          <td>{topic.count}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td>N/A</td>
                      <td>N/A</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Card>
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
    </>
  );
};

export default TopicsCount;
